/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Submit_NowInputs */

const vi_irrigation_run_submit_now = /** @type {(inputs: Irrigation_Run_Submit_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật bơm`)
};

/**

* @param {Irrigation_Run_Submit_NowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_submit_now = /** @type {((inputs?: Irrigation_Run_Submit_NowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Submit_NowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_submit_now(inputs)
});